export const statesWithCodes = [
  { name: "Andhra Pradesh", code: "AP" },
  { name: "Arunachal Pradesh", code: "ARP" },
  { name: "Assam", code: "ASS" },
  { name: "Bihar", code: "BIH" },
  { name: "Chhattisgarh", code: "CHA" },
  { name: "Goa", code: "GOA" },
  { name: "Gujarat", code: "GUJ" },
  { name: "Haryana", code: "HAR" },
  { name: "Himachal Pradesh", code: "HP" },
  { name: "Jharkhand", code: "JHA" },
  { name: "Karnataka", code: "KAR" },
  { name: "Kerala", code: "KER" },
  { name: "Madhya Pradesh", code: "MP" },
  { name: "Maharashtra", code: "MAH" },
  { name: "Manipur", code: "MAN" },
  { name: "Meghalaya", code: "MEG" },
  { name: "Mizoram", code: "MIZ" },
  { name: "Nagaland", code: "NAG" },
  { name: "Odisha", code: "ODI" },
  { name: "Punjab", code: "PUN" },
  { name: "Rajasthan", code: "RAJ" },
  { name: "Sikkim", code: "SIK" },
  { name: "Tamil Nadu", code: "TN" },
  { name: "Telangana", code: "TEL" },
  { name: "Tripura", code: "TRI" },
  { name: "Uttar Pradesh", code: "UP" },
  { name: "Uttarakhand", code: "UTT" },
  { name: "West Bengal", code: "WB" },

  // Union Territories
  { name: "Andaman and Nicobar Islands", code: "ANI" },
  { name: "Chandigarh", code: "CHD" },
  { name: "Dadra and Nagar Haveli and Daman and Diu", code: "DD" },
  { name: "Delhi", code: "DEL" },
  { name: "Jammu and Kashmir", code: "JK" },
  { name: "Ladakh", code: "LD" },
  { name: "Lakshadweep", code: "LAK" },
  { name: "Puducherry", code: "PUD" },
];

export const indianLanguages = [
  "Hindi",
  "English",
  "Bengali",
  "Telugu",
  "Marathi",
  "Tamil",
  "Gujarati",
  "Urdu",
  "Kannada",
  "Odia",
  "Malayalam",
  "Punjabi",
  "Assamese",
  "Maithili",
  "Santali",
];
